export type ErrorWithMessage = {
  message: string;
  response?: any;
};

class Logger {
  logger = console;

  // Keys already reported by warnOnce/errorOnce, prefixed by level; resetOnce clears them for independent test cases.
  private readonly reported = new Set<string>();

  log(message: ErrorWithMessage | string) {
    this.logger.log(message);
  }

  warn(warning: ErrorWithMessage | string) {
    this.logger.warn(warning);
  }

  error(error: ErrorWithMessage | string) {
    this.logger.error(error);
  }

  // For messages produced on every render or row: the first report per key and level is kept, the rest are dropped.
  // Key by category (plus a bounded discriminator if useful), not by the raw value, so the set stays small.
  warnOnce(key: string, warning: ErrorWithMessage | string) {
    if (this.firstReport(`warn:${key}`)) this.warn(warning);
  }

  errorOnce(key: string, error: ErrorWithMessage | string) {
    if (this.firstReport(`error:${key}`)) this.error(error);
  }

  resetOnce() {
    this.reported.clear();
  }

  private firstReport(levelKey: string): boolean {
    if (this.reported.has(levelKey)) return false;

    this.reported.add(levelKey);

    return true;
  }
}

export const logger = new Logger();
